import I18n from 'i18n-js';
import React from 'react';
import PropTypes from 'prop-types';
import UiIcon from '@material-ui/core/Icon';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';

/**
 * Icon allows repositioning by x and y props.
 **/
const icons = {
  'warning-tag': {
    viewBox: '0 0 20 20',
    content: (
      <>
        <path fill="#FED62C" d="M6.11,0,0,10.16H12.22ZM5.56,9V7.94h1.1V9Z" />
        <rect fill="#000000" x="5.56" y="7.94" width="1.1" height="1.11" />
        <rect fill="#000000" x="5.56" y="3.5" width="1.1" height="3.33" />
      </>
    ),
  },
  warning: {
    viewBox: '0 0 12 12',
    content: (
      <>
        <path d="M6.11,0,0,10.16H12.22ZM5.56,9V7.94h1.1V9Z" />
        <rect fill="#404040" x="5.56" y="7.94" width="1.1" height="1.11" />
        <rect fill="#404040" x="5.56" y="3.5" width="1.1" height="3.33" />
      </>
    ),
  },
  info: {
    viewBox: '0 0 12 12',
    content: (
      <>
        <circle cx="6" cy="6" r="5" />
        <rect fill="#003bcc" x="5.56" y="7.94" width="1.1" height="1.11" />
        <rect fill="#003bcc" x="5.56" y="3.5" width="1.1" height="3.33" />
      </>
    ),
  },
  info_2: {
    viewBox: '0 0 24 24',
    content: (
      <path
        fill="#f0f0f0"
        d="M 21.398438 10.601563 L 13.398438 2.601563 C 12.601563 1.800781 11.398438 1.800781 10.601563 2.601563 L 2.601563 10.601563 C 1.800781 11.398438 1.800781 12.601563 2.601563 13.398438 L 10.601563 21.398438 C 11.398438 22.199219 12.601563 22.199219 13.398438 21.398438 L 21.398438 13.398438 C 22.199219 12.601563 22.199219 11.398438 21.398438 10.601563 Z M 13 17 L 11 17 L 11 15 L 13 15 Z M 13 13 L 11 13 L 11 7 L 13 7 Z "
      />
    ),
  },
  question: {
    viewBox: '0 0 24 24',
    content: (
      <path d="M20,2H4C2.895,2,2,2.895,2,4v18l4-4h14c1.105,0,2-0.895,2-2V4C22,2.895,21.105,2,20,2z M13,14h-2v-2h2V14z M15,9 c0,0.38-0.21,0.72-0.55,0.89L13,10.62V11h-2v-1c0-0.38,0.21-0.72,0.55-0.89L13,8.38V7h-2v1.08H9V6c0-0.55,0.45-1,1-1h4 c0.55,0,1,0.45,1,1V9z" />
    ),
  },
  presentation: {
    viewBox: '0 0 24 24',
    content: (
      <path d="M 2 2 L 2 4 L 22 4 L 22 2 Z M 2 5 L 2 17 C 2 18.105469 2.894531 19 4 19 L 11 19 L 11 22 L 13 22 L 13 19 L 20 19 C 21.105469 19 22 18.105469 22 17 L 22 5 Z M 4 7 L 20 7 L 20 16.5 C 20 16.777344 19.777344 17 19.5 17 L 4.5 17 C 4.222656 17 4 16.777344 4 16.5 Z M 13 8 L 13 10 L 19 10 L 19 8 Z M 8 9 C 6.34375 9 5 10.34375 5 12 C 5 13.65625 6.34375 15 8 15 C 9.65625 15 10.96875 13.640625 11 12 L 8 12 Z M 13 11 L 13 13 L 19 13 L 19 11 Z M 13 14 L 13 16 L 19 16 L 19 14 Z " />
    ),
  },
  recording: {
    viewBox: '0 0 24 24',
    content: (
      <>
        <circle cx="12" cy="5.7" r="3.8" />
        <path d="M18.5 15.1c-.6 0-1.1.2-1.5.7-.4.5-.6 1.1-.6 1.9 0 .8.2 1.5.5 1.9.4.4.9.6 1.5.6.3 0 .6 0 .8-.1.3-.1.6-.1.8-.2v1c-.5.2-1.1.3-1.8.3-1 0-1.8-.3-2.3-.9-.5-.6-.8-1.5-.8-2.6 0-.7.1-1.3.4-1.9.3-.5.6-.9 1.1-1.2.5-.3 1.1-.4 1.7-.4.7 0 1.3.1 1.9.4l-.2.9c-.2-.1-.5-.2-.7-.3-.3-.1-.5-.1-.8-.1zM14.1 21h-3.9v-6.8h3.9v.9h-2.7V17H14v.9h-2.6V20h2.7v1zm-8.9-2.7V21H4.1v-6.8H6c.9 0 1.5.2 2 .5.4.3.6.8.6 1.5 0 .9-.4 1.5-1.3 1.8l1.9 3H8l-1.6-2.7H5.2zm0-.9H6c.5 0 .9-.1 1.1-.3.2-.2.4-.5.4-.9s-.1-.7-.4-.8c-.3-.2-.6-.3-1.1-.3h-.8v2.3z" />
      </>
    ),
  },
  record: {
    viewBox: '0 0 24 24',
    content: (
      <path d="M 12 5 C 8.1340068 5 5 8.1340068 5 12 C 5 15.865993 8.1340068 19 12 19 C 15.865993 19 19 15.865993 19 12 C 19 8.1340068 15.865993 5 12 5 z" />
    ),
  },
  pip_on: {
    viewBox: '0 0 24 24',
    content: (
      <>
        <path d="M6.7 13.6c-.6 0-1.1-.5-1.1-1.1V7.4c0-.6.5-1.1 1.1-1.1H13c.6 0 1.1.5 1.1 1.1v5.1c0 .6-.5 1.1-1.1 1.1H6.7z" />
        <path d="M9.6 17.5H3.5v-13h16v6h2v-6c0-1.1-.9-2-2-2h-16c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h6.1v-2zM21.5 20.5v-7h-2v3.6l-2.8-2.7-1.4 1.4 2.8 2.7h-3.6v2h7z" />
      </>
    ),
  },
  pip_off: {
    viewBox: '0 0 24 24',
    content: (
      <>
        <path d="M9.6 17.5H3.5v-13h16v6h2v-6c0-1.1-.9-2-2-2h-16c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h6.1v-2z" />
        <path d="M5.6 6.3v7h2V9.7l2.8 2.7 1.4-1.4L9 8.3h3.6v-2h-7zM13.2 21.5c-.8 0-1.4-.6-1.4-1.4v-6.4c0-.8.6-1.4 1.4-1.4h7.9c.8 0 1.4.6 1.4 1.4v6.4c0 .8-.6 1.4-1.4 1.4h-7.9z" />
      </>
    ),
  },
  fav: {
    viewBox: '0 0 20 19',
    content: (
      <path d="M10 18.35l-1.45-1.32C3.4 12.36 0 9.28 0 5.5 0 2.42 2.42 0 5.5 0 7.24 0 8.91.81 10 2.09 11.09.81 12.76 0 14.5 0 17.58 0 20 2.42 20 5.5c0 3.78-3.4 6.86-8.55 11.54L10 18.35z" />
    ),
  },
  cast_connected: {
    viewBox: '0 0 24 24',
    content: (
      <path d="M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2a9 9 0 0 1 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
    ),
  },
};

const useIconColors = makeStyles((theme) => {
  const iconColor =
    theme.palette.type === 'light'
      ? theme.palette.grey[900]
      : theme.palette.grey[50];

  return { root: { fill: iconColor, color: iconColor } };
});

const Icon = ({
  id,
  x,
  y,
  type,
  title,
  role,
  warning,
  fontSize,
  onClick,
  className,
  ...props
}) => {
  const icon = icons[type];
  const classes = useIconColors(props);

  if (!icon) {
    return (
      <UiIcon
        className={classNames(classes.root, className)}
        fontSize={fontSize}
      >
        {type}
      </UiIcon>
    );
  }

  return (
    <svg
      className={classNames('icon', 'icon-' + type, classes.root, className)}
      onClick={onClick}
      viewBox={icon.viewBox}
      x={x}
      y={y}
      id={id}
    >
      <title>{title}</title>
      {icon.content}
      {warning && (
        <Icon type="warning-tag" x="-5" title={I18n.t('alt:warning')} />
      )}
    </svg>
  );
};

Icon.propTypes = {
  x: PropTypes.string,
  y: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
  warning: PropTypes.bool,
  onClick: PropTypes.func,
};

Icon.defaultProps = { warning: false };

export default Icon;
